<template>
  <v-container class="app">
    <v-row>
      <v-row>
        <v-col cols="12">
          <v-form ref="survey-effort">
            <v-col cols="12" md="6">
              <label class="datepicker-label">Trial Date:</label>
              <Datepicker
                v-model="record.deploy_date"
                uid="survey-effort-deploy-date"
                format="yyyy-MM-dd"
                :enable-time-picker="false"
                placeholder="deployment date"
                type="date"
                clearable
                menu-class="w-96"
                teleport
              />
              <v-tooltip
                activator="#dp-input-survey-effort-deploy-date"
                location="top"
                open-delay="300"
              >
                Select deployment date to see a list of locations.
              </v-tooltip>
            </v-col>
          </v-form>
        </v-col>
      </v-row>
    </v-row>
  </v-container>
</template>

<script>
import { support } from "search-observe-app";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
export default {
  name: "Survey-Effort-Form",
  components: { Datepicker },
  props: {
    notSearch: Boolean,
    selected_record: Object,
  },
  data() {
    return {
      handler: {
        submit: this.submit,
      },
      required: [(v) => !!v || "Required"],
      record: this.selected_record,
    };
  },
  created() {
    this.$watch(
      "selected_record",
      () => {
        this.record = this.selected_record;
      },
      { deep: true }
    );
    this.$watch(
      "username",
      () => {
        console.log(this.username);
        if (
          this.record_observer_code === "guest" ||
          this.record_observer_code === ""
        ) {
          this.record.observer_code = this.username;
        }
      },
      { deep: true }
    );
    if (
      !this.notSearch &&
      (this.record.observer_code === "guest" ||
        this.record.observer_code === "")
    ) {
      this.record.observer_code = this.username;
    }
  },

  mounted() {
    this.record = this.selected_record;
    if (this.record.observer_code === "guest") {
      this.record.observer_code = this.username;
    }
  },
  methods: {
    submit() {
      if (
        this.record.observer_code === "guest" ||
        this.record.observer_code === "" ||
        this.record.observer_code === null
      ) {
        this.record.observer_code = this.username;
      }
      if (
        this.record.survey_tablet === "" ||
        this.record.survey_tablet === null
      ) {
        this.record.survey_tablet = this.$store.getters["shared/tabletCode"];
      }
      let record = support.forceFieldType(support.data.SURVEYEFFORTFIELDS, [
        this.record,
      ]);
      record.insert_ts = support.getLocalTimestamp(new Date());
      record.incidental = "true";
      support.saveRecord(support.data.SURVEYEFFORT, record[0]); //record is a list after force fields
    },
  },
  computed: {
    currentCoordinates() {
      return support.getLatitude() + " " + support.getLongitude();
    },
    showIncidental() {
      return !support.hasCrumbs(this.record);
    },
    username: {
      get() {
        return this.$store.getters["shared/username"];
      },
      set(newvalue) {
        this.record.observer_code = newvalue;
      },
    },
    refTables() {
      return this.$store.getters["shared/refTables"];
    },
  },
};
</script>
